import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
  container: {

    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0,
  },
  logotypeContainer: {

    width: "65%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  logotypeImage: {
    width: '100%',
    height: "105%",
    background: "white",
    paddingTop: '0%',
  paddingLeft: '0%',
  paddingRight: '0%',


  },
  logotypeImageApp: {
    width: '100%',
    height: "90px",
    background: "white",
    paddingTop: '10px',
    paddingLeft: '0%',
    paddingRight: '0%',



  },
  logotypeText: {
    color: "white",
    fontWeight: 500,
    fontSize: 84,
    [theme.breakpoints.down("md")]: {
      fontSize: 48,
    },
    textAlign:"center",
  },
  formContainer: {
    width: "70%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "95%",
    }
  },
  form: {

    width: 320,
  },
  tab: {
    fontWeight: 400,
    fontSize: 18,
  },
  greeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: theme.spacing(4),
  },
  subGreeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: theme.spacing(2),
  },
  googleButton: {
    marginTop: theme.spacing(6),
    boxShadow: theme.customShadows.widget,
    backgroundColor: "white",
    width: "100%",
    textTransform: "none",
  },
  googleButtonCreating: {
    marginTop: 0,
  },
  googleIcon: {
    width: 30,
    marginRight: theme.spacing(2),
  },
  creatingButtonContainer: {
    marginTop: theme.spacing(2.5),
    height: 46,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  createAccountButton: {
    height: 46,
    textTransform: "none",
  },
  formDividerContainer: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    display: "flex",
    alignItems: "center",
  },
  formDividerContainerBu:{
    marginTop: theme.spacing(6),
    display: "flex",
    alignItems: "center",
  },
  formDividerWord: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    color: '#007aa1',


  },
  formDivider: {
    flexGrow: 0.5,
    height: 0.5,
    backgroundColor: theme.palette.text.hint + "40",
  },
  errorMessage: {
    textAlign: "center",
  },
  textFieldUnderline: {
    "&:before": {
      borderBottomColor: theme.palette.primary.light,
    },
    "&:after": {
      borderBottomColor: theme.palette.primary.main,
    },
    "&:hover:before": {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    borderBottomColor: theme.palette.background.light,
  },
  formButtons: {
    width: "100%",
    marginTop: theme.spacing(0),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  forgetButton: {
    textTransform: "none",
    fontWeight: 400,
  },
  loginLoader: {
    marginLeft: theme.spacing(4),
  },
  copyright: {

    marginTop: theme.spacing(7),
    whiteSpace: "nowrap",
    [theme.breakpoints.up("md")]: {
      position: "relative",

      bottom: theme.spacing(2),
    },
  },
  titleArabe:{
    fontSize: 25,

  },logo_title:{
    width: "10vw",
  },
  logoTitleContainer:{
    backgroundColor: '#007aa2d1',
    width: "100%",
    height: "20%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },

    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  imageLogo:{
    width: "20%",

    [theme.breakpoints.down("md")]: {
      width: "20%",
    },
    [theme.breakpoints.down("sm")]: {
      width: "44%",
    },
  },

  formDivider2: {
    flexGrow: 1,
    height: 3,
    backgroundColor: '#179bd7',
  },
  divWith:{
    color:"white",
  },
  loginGrid:{
    padding: theme.spacing(1),
  },
  loginIcon:{
    fontSize:70,
    padding: theme.spacing(0),
  },
  formBtn:{
    backgroundColor:'#b7b1b1 !important',
  }
}));
